import { useEffect } from 'react';
import { Button, Spinner } from '@blacknbrownstudios/ui';
import { useChatStore } from '../stores/chat';
import { ConversationItem } from './ConversationItem';
import { ModelSelector } from './ModelSelector';

export function Sidebar() {
  const {
    conversations,
    activeConversationId,
    isLoadingConversations,
    loadConversations,
    loadServers,
    selectConversation,
    createNewConversation,
    removeConversation,
    renameConversation,
  } = useChatStore();

  useEffect(() => {
    loadConversations();
    loadServers();
  }, [loadConversations, loadServers]);

  const handleNewChat = async () => {
    try {
      const id = await createNewConversation();
      selectConversation(id);
    } catch (e) {
      console.error('Failed to create conversation:', e);
    }
  };

  return (
    <aside className="w-72 bg-neutral-900 border-r border-neutral-800 flex flex-col h-full">
      {/* Header */}
      <div className="p-4 border-b border-neutral-800">
        <Button
          onClick={handleNewChat}
          variant="contained"
          color="primary"
          fullWidth
          startIcon={
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
          }
        >
          New Chat
        </Button>
      </div>

      {/* Conversations list */}
      <div className="flex-1 overflow-y-auto chat-scrollbar p-2">
        {isLoadingConversations ? (
          <div className="flex items-center justify-center py-8">
            <Spinner size="medium" color="primary" />
          </div>
        ) : conversations.length === 0 ? (
          <div className="text-center py-8 text-neutral-500">
            <p className="text-sm">No conversations yet</p>
            <p className="text-xs mt-1">Start a new chat to begin</p>
          </div>
        ) : (
          <div className="space-y-1">
            {conversations.map((conversation) => (
              <ConversationItem
                key={conversation.id}
                conversation={conversation}
                isActive={conversation.id === activeConversationId}
                onSelect={() => selectConversation(conversation.id)}
                onDelete={() => removeConversation(conversation.id)}
                onRename={(title) => renameConversation(conversation.id, title)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="border-t border-neutral-800">
        <div className="p-2">
          <ModelSelector />
        </div>
        <div className="px-4 pb-3 pt-1 text-xs text-neutral-500">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-primary-500" />
            Binks Agent
          </div>
        </div>
      </div>
    </aside>
  );
}
